export function toNumber(text: string): number {
  return +(text.replace(',', '.'));
}
